module.exports = __webpack_public_path__ + "static/media/organization-office-building-notification-red.5f017fff.svg";